import React, { useState } from 'react';
import './styles/layout.css';
import logo from './assets/logo.png';
import AnimatedButton from './components/AnimatedButton';
import { FaFacebookF, FaInstagram, FaLinkedinIn, FaTwitter } from "react-icons/fa";
import HorecaFaqs from './components/horeca/horecafaqs';
import { useNavigate } from 'react-router-dom';
import { useLocation } from 'react-router-dom';


const HorecaLayout = ({ children }) => {
  const location = useLocation();
   const navigate = useNavigate(); 
  const [activeLink, setActiveLink] = useState(location.pathname);
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const handleLinkClick = (link) => {
    setActiveLink(link);
    setIsMenuOpen(false); // Close menu when clicking a link
    navigate(link);
  };

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <div className="layout">
      <nav className="navbar">
        <div className="navbar-logo">
          <img src={logo} width="120rem" alt="Logo" onClick={()=>handleLinkClick('/')} style={{cursor:'pointer'}}/>
        </div>
        <div className={`navbar-menu ${isMenuOpen ? 'open' : ''}`}>
          <ul>
            <li>
              <a
                href="/Horeca-Home"
                className={activeLink === '/Horeca-Home' ? 'active' : ''}
                onClick={() => handleLinkClick('/Horeca-Home')}
              >
                Home
              </a>
            </li>
            <li>
              <a
                href="/Horeca-AboutUs"
                className={activeLink === '/Horeca-AboutUs' ? 'active' : ''}
                onClick={() => handleLinkClick('/Horeca-AboutUs')}
              >
                About Us
              </a>
            </li>
            <li>
              <a
                href="/Horeca-Products"
                className={activeLink === '/Horeca-Products' ? 'active' : ''}
                onClick={() => handleLinkClick('/Horeca-Products')}
              >
                Products
              </a>
            </li>
          </ul>
          <a onClick={() => handleLinkClick('/Horeca-Contact')}><AnimatedButton text="Contact Us" link="" /></a>
        </div>
        <div className="hamburger" onClick={toggleMenu}>
          <div />
          <div />
          <div />
        </div>
      </nav>


      <main className="content">
      { children }
        <HorecaFaqs/>
      </main>


      <footer className="footer">
      <div className="footer-top">
        <div className="footer-logo">
          <img src={logo} alt="Logo" width="120" onClick={()=>handleLinkClick('/')} style={{cursor:'pointer'}} />
        </div>
        <div className="footer-menu">
          <ul>
            <li><a onClick={() => handleLinkClick('/Horeca-Home')} >Home</a></li>
            <li><a  onClick={() => handleLinkClick('/Horeca-AboutUs')}>About Us</a></li>
            <li><a  onClick={() => handleLinkClick('/Horeca-Products')}>Products</a></li>
            <li><a  onClick={() => handleLinkClick('/Horeca-Contact')}>Contact Us</a></li>
          </ul>
        </div>
      </div>
      <div className="footer-middle">
        <div className="subscribe-section">
          <h3>Subscribe</h3>
          <p>Stay up to date with our latest news and articles.</p>
          <div className="subscribe-form">
            <input type="email" placeholder="Enter your email" />
            <button>Submit</button>
          </div>
        </div>
        <div className="social-links">
          <h4>FOLLOW US:</h4>
          <div className="icons">
            <a href="https://www.linkedin.com/company/companysix/" aria-label="Facebook"><FaFacebookF /></a>
            <a href="https://www.linkedin.com/company/companysix/" aria-label="Instagram"><FaInstagram /></a>
            <a href="https://www.linkedin.com/company/companysix/" aria-label="LinkedIn"><FaLinkedinIn /></a>
            <a href="https://www.linkedin.com/company/companysix/" aria-label="Twitter"><FaTwitter /></a>
          </div>
        </div>
      </div>
      <div className="footer-bottom">
        <p>© - CO6 Group, All rights are reserved.</p>
      </div>
    </footer>
    </div>
  );
};

export default HorecaLayout;
